export default __webpack_public_path__ + "static/media/KillerJupiter.70d0f756.jpg";